import { Controller } from "@hotwired/stimulus"
// "motion/mini" : moteur WAAPI minimal (~5 Ko) — le moteur hybride complet
// de "motion" pèserait ~190 Ko de plus dans le bundle pour le même rendu ici.
import { animate } from "motion/mini"
import { inView, stagger } from "motion"

// Apparition douce au scroll (librairie Motion). L'état initial est posé en JS :
// sans JavaScript, le contenu reste visible (aucun impact SEO).
//
//   data-controller="reveal"                     → anime l'élément lui-même
//   data-reveal-selector-value=".card"           → anime ses enfants en cascade
//   data-reveal-y-value="16" / -stagger-value / -duration-value pour ajuster
export default class extends Controller {
  static values = {
    selector: String,
    y: { type: Number, default: 24 },
    duration: { type: Number, default: 0.6 },
    stagger: { type: Number, default: 0.08 }
  }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.items = this.hasSelectorValue
      ? Array.from(this.element.querySelectorAll(this.selectorValue))
      : [this.element]
    if (this.items.length === 0) return

    for (const el of this.items) {
      el.style.opacity = "0"
      el.style.transform = `translateY(${this.yValue}px)`
    }

    this.stopInView = inView(this.element, () => {
      animate(
        this.items,
        { opacity: 1, transform: "translateY(0px)" },
        { duration: this.durationValue, delay: stagger(this.staggerValue), ease: [0.22, 1, 0.36, 1] }
      )
      this.stopInView?.()
      this.stopInView = null
    }, { amount: 0.15 })
  }

  // Turbo met les pages en cache : on rend tout visible avant de quitter,
  // sinon la page restaurée (bouton retour) garderait des éléments masqués.
  disconnect() {
    this.stopInView?.()
    for (const el of this.items || []) {
      el.style.opacity = ""
      el.style.transform = ""
    }
  }
}
